const temporarySystemNotice = {
  enabled: true,
  from: '2026-06-01',
  to: '2026-06-05'
}

function getNoticeDate (date, time) {
  return new Date(`${date}T${time}`)
}

function formatNoticeDate (date) {
  const parts = date.split('-')
  return `${parts[2]}.${parts[1]}`
}

export function temporarySystemNoticeIsActive (date = new Date()) {
  if (!temporarySystemNotice.enabled) {
    return false
  }

  return date >= getNoticeDate(temporarySystemNotice.from, '00:00:00') &&
    date <= getNoticeDate(temporarySystemNotice.to, '23:59:59')
}

export function temporarySystemNoticeDateRange () {
  return `${formatNoticeDate(temporarySystemNotice.from)} - ${formatNoticeDate(temporarySystemNotice.to)}.${temporarySystemNotice.to.split('-')[0]}`
}

export default temporarySystemNotice
